// 这里配置具体的CGI路径
/**
 * 凡是用到api.js这个Redux中间件的，所请求的CGI路径都会在这里找，请注意！
 */
import value from 'js/common/value';
import {
    GET_USER_ALBUM,
    GET_USER_INFO,
    GET_QQHY_USER_INFO,
    SET_USER_INFO,
    SET_USER_INFO_TYPE,
    FOLLOW,
    GET_FOLLOW,
    GET_FANS,
    SET_USER_VOICE_COVER,
    GET_USER_VOICE_COVER,
    GET_ROOM_CONFIG,
    GET_MANAGER_LIST,
    GET_MUTE_LIST,
    GET_FORBID_LIST,
    GET_SEQUENCE_RECORD,
    SET_ROOM_PLAY_TYPE,
    SET_ROOM_CONFIG,
    SET_ROOM_MANAGER,
    SET_FORBID_STATUS,
    GIFT_PAY_SWITCH,
    GET_BALANCE,
    EDIT_ANCHOR_CONFIG,
    EDIT_ROOM_NAME,
    EDIT_ROOM_STAGE_MODE,
    GET_CHARM_DAY,
    GET_CHARM_WEEK,
    GET_RICH_DAY,
    GET_RICH_WEEK,
    GET_CONTRIBUTION,
    GET_ANCHOR,
    GET_LINE_DETAIL,
    EDIT_LINE_USER,
    SET_USER_ALBUM,
    GET_TASK_INFO,
    GET_TASK_AWARD,
    GET_USER_EXP_LEV,
    GET_ACTIVE_INFO,
    GET_ACTIVE_AWARD,
    GET_PERSONAL_CENTER,
    GET_ROOM_TRACE,
    CLEAN_ROOM_TRACE,
    GET_TRANSIT_PAGE_INFO,
    GET_USER_BADGES,
    GET_NOBILITY_INFO,
    GET_RELEGATION_INFO,
    GET_ENTRY_INFO_V2,
    GET_QUN_ROOM,
    GET_QUN_SAME_CITY_ROOM,
    GET_QUN_KSONG_JIAOYOU_ROOM,
    EDIT_STAGE,
    WITHDRAW,
    GET_CASH_RECORD_LIST,
    GET_SHOW_EARNINGS_LIST,
    GET_MANAGE_EARNINGS_LIST,
    GET_HOST_EARNINGS_DETAIL,
    SET_HALL_OPTION,
    GET_HOST_INFO,
    SET_HOST_INFO,
    UPLOAD_IMAGE,
    GET_DAY_RANK_LIST,
    GET_WEEK_RANK_LIST,
    GET_RECORD_LIST,
    GET_MYRECORD_LIST,
    GET_DRAW_RESULT,
    GET_GIFT_CONFIG,
    GET_DRAW_EXCHANGE,
    GET_MY_GROUP,
} from './constants';

// 是客户端测试环境的时候，将url走cgi-bin-test，这个cgi是直接发外网的。
const videohubBaseUrl = value.isHuayangClientDev
    ? '//qvideo.qq.com/cgi-bin-test/videohub'
    : '//qvideo.qq.com/cgi-bin/videohub';
const rankListBaseUrl = value.isHuayangClientDev
    ? '//qvideo.qq.com/cgi-bin-test/dolphin_act/videohub'
    : '//qvideo.qq.com/cgi-bin/dolphin_act/videohub';
const lotteryBaseUrl = value.isHuayangClientDev
    ? '//qvideo.qq.com/cgi-bin-test/lottery/videohub'
    : '//qvideo.qq.com/cgi-bin/lottery/videohub';

var CGI_PATH = {
    [GET_USER_ALBUM]: `${videohubBaseUrl}/get_user_album`,
    [GET_USER_INFO]: `${videohubBaseUrl}/get_user_info`,
    [GET_USER_BADGES]: `${videohubBaseUrl}/get_badge_info`,
    [GET_QQHY_USER_INFO]: `${videohubBaseUrl}/get_qqhy_user_info`,
    [SET_USER_ALBUM]: `${videohubBaseUrl}/set_user_album`,
    [SET_USER_INFO]: `${videohubBaseUrl}/set_user_info`,
    [SET_USER_INFO_TYPE]: `${videohubBaseUrl}/set_user_info_type`,
    [FOLLOW]: `${videohubBaseUrl}/follow`,
    [GET_FOLLOW]: `${videohubBaseUrl}/get_follow`,
    [GET_FANS]: `${videohubBaseUrl}/get_fans`,
    [SET_USER_VOICE_COVER]: `${videohubBaseUrl}/set_user_voice_cover`,
    [GET_USER_VOICE_COVER]: `${videohubBaseUrl}/get_user_voice_cover`,
    // 房间管理
    [GET_MANAGER_LIST]: `${videohubBaseUrl}/room/get_manager_list`,
    [GET_ROOM_CONFIG]: `${videohubBaseUrl}/room/management/get_room_config`,

    [GET_MANAGER_LIST]: `${videohubBaseUrl}/room/get_manager_list`,
    [GET_MUTE_LIST]: `${videohubBaseUrl}/room/get_forbid_list`,
    [GET_FORBID_LIST]: `${videohubBaseUrl}/room/get_forbid_list`,
    [GET_SEQUENCE_RECORD]: `${videohubBaseUrl}/room/get_operation_record`,

    [EDIT_ANCHOR_CONFIG]: `${videohubBaseUrl}/anchor_sequence/edit_anchor_config`,
    [EDIT_ROOM_NAME]: `${videohubBaseUrl}/room/edit_room_name`,
    [EDIT_ROOM_STAGE_MODE]: `${videohubBaseUrl}/room/edit_room_stage_mode`,
    [SET_ROOM_CONFIG]: `${videohubBaseUrl}/room/management/set_room_config`,
    [SET_ROOM_MANAGER]: `${videohubBaseUrl}/room/set_room_manager`,
    [SET_ROOM_PLAY_TYPE]: `${videohubBaseUrl}/room/management/set_room_play_type`,
    [SET_FORBID_STATUS]: `${videohubBaseUrl}/room/permit`,
    // 充值页
    [GET_BALANCE]: `${videohubBaseUrl}/get_balance`,
    [GIFT_PAY_SWITCH]: `${videohubBaseUrl}/gift_pay_switch`,

    // 榜单页
    [GET_CHARM_DAY]: `${rankListBaseUrl}/rank/getList`,
    [GET_CHARM_WEEK]: `${rankListBaseUrl}/rank/getList`,
    [GET_RICH_DAY]: `${rankListBaseUrl}/rank/getList`,
    [GET_RICH_WEEK]: `${rankListBaseUrl}/rank/getList`,
    [GET_ANCHOR]: `${rankListBaseUrl}/rank/getList`,
    [GET_CONTRIBUTION]: `${rankListBaseUrl}/rank/getList`,

    // 连麦
    [GET_LINE_DETAIL]: `${videohubBaseUrl}/line/get_line_detail`,
    [EDIT_LINE_USER]: `${videohubBaseUrl}/line/edit_line_user`,

    // 每日任务
    [GET_TASK_INFO]: `${videohubBaseUrl}/task/get_task_info`,
    [GET_TASK_AWARD]: `${videohubBaseUrl}/task/get_task_award`,
    [GET_ACTIVE_INFO]: `${videohubBaseUrl}/task/get_active_info`,
    [GET_ACTIVE_AWARD]: `${videohubBaseUrl}/task/get_active_award`,

    // 我的等级
    [GET_USER_EXP_LEV]: `${videohubBaseUrl}/task/get_user_exp_lev`,

    // 获取个人中心资料
    [GET_PERSONAL_CENTER]: `${videohubBaseUrl}/get_personal_center`,
    [GET_ROOM_TRACE]: `${videohubBaseUrl}/get_room_trace`,
    [CLEAN_ROOM_TRACE]: `${videohubBaseUrl}/clean_room_trace`,

    // 承接页
    [GET_TRANSIT_PAGE_INFO]: `${videohubBaseUrl}/transit/get_transit_page_info`,

    // 承接页V2
    [GET_ENTRY_INFO_V2]: `${videohubBaseUrl}/transit/get_transit_page_info_v2`,
    // 提现相关
    [WITHDRAW]: `${videohubBaseUrl}/website/host/withdraw`,
    [GET_CASH_RECORD_LIST]: `${videohubBaseUrl}/website/host/get_cash_record_list`,
    [GET_SHOW_EARNINGS_LIST]: `${videohubBaseUrl}/website/host/get_show_earnings_list`,
    [GET_MANAGE_EARNINGS_LIST]: `${videohubBaseUrl}/website/union/get_manage_earnings_list`,
    [GET_HOST_EARNINGS_DETAIL]: `${videohubBaseUrl}/website/union/get_host_earnings_detail`,

    // 承接页v2打开状态
    [SET_HALL_OPTION]: `${videohubBaseUrl}/set_hall_option`,

    // 大厅
    [GET_QUN_ROOM]: `${videohubBaseUrl}/rcmd/get_rcmd_by_tab`,
    //同城
    [GET_QUN_SAME_CITY_ROOM]: `${videohubBaseUrl}/rcmd/get_city_by_tab`,
    //K歌和交友
    [GET_QUN_KSONG_JIAOYOU_ROOM]: `${videohubBaseUrl}/rcmd/get_singlove_tab`,

    // 获取爵位信息
    [GET_NOBILITY_INFO]: `${videohubBaseUrl}/nobility/getNobilityInfo`,

    // 获取保级卡信息(黄马褂) /* 保级竟然用Relegation这个词，太惨烈了 */
    [GET_RELEGATION_INFO]: `${videohubBaseUrl}/nobility/getJacketInfo`,

    // 编辑舞台
    [EDIT_STAGE]: `${videohubBaseUrl}/stage/edit_stage`,

    // 主播推荐图设置
    [GET_HOST_INFO]: `${videohubBaseUrl}/website/host/get_host_info`,
    [SET_HOST_INFO]: `${videohubBaseUrl}/website/host/set_host_info`,

    // 图片上传通用接口
    [UPLOAD_IMAGE]: `${videohubBaseUrl}/upload_image`,

    [GET_GIFT_CONFIG]: `${lotteryBaseUrl}/config`,
    // 获取抽奖记录
    [GET_RECORD_LIST]: `${lotteryBaseUrl}/record`,
    [GET_MYRECORD_LIST]: `${lotteryBaseUrl}/myrecord`,

    [GET_DAY_RANK_LIST]: `${rankListBaseUrl}/rank/getList`,
    [GET_WEEK_RANK_LIST]: `${rankListBaseUrl}/rank/getList`,
    [GET_DRAW_RESULT]: `${lotteryBaseUrl}/do`,
    [GET_DRAW_EXCHANGE]: `${lotteryBaseUrl}/exchange`,
    // 获取我加入的群
    [GET_MY_GROUP]: `${videohubBaseUrl}/transit/get_my_group`,
};

export default CGI_PATH;
